import React from "react";
import ReactModal from "react-modal";
import styles from "./styles";
import { Box, Text, Button } from "ui-components";
import Sadface from "assets/images/sad-face-icon.png";
import { ReactComponent as CloseIcon } from "assets/icons/icon-close-X.svg";
import FormattedMessage from "components/FormattedMessage";
import get from "lodash/get";



const ErrorModal = ({ showModal, data, ...props }) => {
  
  const isIMDAPopupEnabled = props?.isIMDAPopupEnabled || false;
  // console.log("ErrorModal props", props);
  const [isModalOpen, setIsModalOpen] = React.useState(showModal && isIMDAPopupEnabled);
 
  return (
    <ReactModal style={styles.ModalStyle} isOpen={isModalOpen}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Header */}
        
        <Box
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1fr auto 1fr",
            alignItems: "flex-start",
            paddingBottom: "24px",
          }}
        >
          <img
            alt="sad face icon"
            src={get(data, "imageSrc") || Sadface}
            width="72"
            height="72"
            style={{ gridColumn: 2, justifySelf: "center" }}
          />

          <Box
            data-testid="close-model-button"
            sx={{ gridColumn: 3, justifySelf: "end", cursor: "pointer" }}
             onClick={() =>  setIsModalOpen(false)}
          >
            <CloseIcon width="44" height="44" />
          </Box>
        </Box>

        {/* Title */}
        <Box>
          <Text
            sx={{
              color: "#101828",
              textAlign: "center",
              fontSize: "20px",
              fontWeight: "600",
              lineHeight: "32px",
              letterSpacing: "-0.72px",
            }}
          >
            <FormattedMessage id={data?.title} />
          </Text>
        </Box>

        {/* Subtitle */}
        <Box sx={{ alignSelf: "stretch" }}>
          <Text
            sx={{
              color: "#475467 !important",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: "normal",
              lineHeight: "24px",
              letterSpacing: "-0.48px",
              maxWidth: "320px",
              mx: "auto",
              whiteSpace: "pre-line", 
            }}
          >
            <FormattedMessage html id={data?.subtitle} /><br/>
            
          </Text>
        </Box>
        <Box sx={{ paddingTop: 4, paddingBottom: 4, width: "100%" }}>
          <Button
            mx={"auto"}
            width={"100%"}
            sx={{
              color: "#FFF",
              fontSize: "16px",
              fontWeight: "normal", // ✅ override default 900
              lineHeight: "24px",
              backgroundColor: "#1A1A1A",
              borderColor: "#1A1A1A !important",
              letterSpacing: "-0.48px",
              borderRadius: "32px",
              boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
              "&:hover": {
                backgroundColor: "#1A1A1A !important",
              },
              
            }}
            onClick={() =>  setIsModalOpen(false)}
          >
            <FormattedMessage id={data?.button_text} />
          </Button>
        </Box>
      </Box>
    </ReactModal>
  );
};

ErrorModal.defaultProps = {
  showModal: false,
};

export default ErrorModal;
